import { render } from "./EmployeePhoto.vue?vue&type=template&id=4ca6e095"
import script from "./EmployeePhoto.vue?vue&type=script&lang=js"
export * from "./EmployeePhoto.vue?vue&type=script&lang=js"

import "./EmployeePhoto.vue?vue&type=style&index=0&id=4ca6e095&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__